export const quoteSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 44,
        borderColor: state.isFocused ? "#0071BB" : "#b8c7d1",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 113, 187, 0.16)" : "none",
        fontSize: 14,
        ":hover": {
            borderColor: state.isFocused ? "#0071BB" : "#8fa4b2",
        },
    }),
    valueContainer: (base) => ({
        ...base,
        minHeight: 42,
        padding: "2px 12px",
    }),
    input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: 14 }),
    placeholder: (base) => ({ ...base, color: "#657786", fontSize: 14 }),
    singleValue: (base) => ({ ...base, color: "#183044", fontSize: 14 }),
    indicatorsContainer: (base) => ({ ...base, height: 42 }),
};

export const quoteSelectMenuStyles = {
    ...quoteSelectStyles,
    menuPortal: (base) => ({ ...base, zIndex: 1050 }),
};
